'use strict';

var optionsCtrl = ['$uibModal', '$translate', 'dialog', '$timeout', function ($uibModal, $translate, dialog, $timeout) {
    var _this = this;
    _this.editMode = [];

    function parseOptionsFromClipboard(clipboardText) {
        var parsed = clipboardText.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
        if (!parsed || parsed.length === 0) {
            return [];
        }
        var used = {};
        var result = [];
        parsed.forEach(function (value) {
            value = value.trim().replace(/"/g, '');
            if (!value || used[value]) {
                return;
            }
            used[value] = true;
            result.push(value);
        });
        return result;
    }

    _this.addOption = function (newValue) {
        _this.options = _this.options || [];
        newValue = newValue.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);

        newValue = newValue || [];
        newValue = newValue.map(function (value) {
            value = value.trim();
            value = value.replace(/\"/g, '');
            return value;
        }).filter(function (value) {
            if (_this.options.indexOf(value) > -1) {
                return false;
            }
            return true;
        });
        _this.options = _this.options.concat(newValue);
        _this.newOption = null;
        return;
    };
    _this.edit = function (index) {
        _this.editMode[index] = true;
        $timeout(function () {
            var ele = document.getElementById('chip_item_' + index);
            ele.focus();
        }, 100);
    }
    _this.copyOptions = function () {
        var copyElement = document.createElement("textarea");
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        var str = _this.options.reduce(function (acc, val) {
            acc = acc + '"' + val.replace('"', '') + '",';
            return acc;
        }, '')
        str = str.substring(0, str.length - 1);;
        copyElement.textContent = str;
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
    };

    _this.pasteOptions = function () {
        if (!navigator.clipboard || !navigator.clipboard.readText) {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_CLIPBOARD_UNAVAILABLE_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_CLIPBOARD_UNAVAILABLE_BODY')
            );
            return;
        }

        navigator.clipboard.readText().then(function (clipboardText) {
            var parsedOptions = parseOptionsFromClipboard(clipboardText);

            if (parsedOptions.length === 0) {
                _this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_INVALID_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_INVALID_BODY')
                );
                return;
            }

            $timeout(function () {
                _this.options = parsedOptions;
            });
        }).catch(function () {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_READ_FAILED_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_READ_FAILED_BODY')
            );
        });
    };

    _this.errorMessage = function (title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant('DASHBOARD.CLOSE'),
            size: 'md'
        });
    };

    _this.removeChip = function (index) {
        _this.options.splice(index, 1);
    };
    _this.removeAll = function () {
        _this.options = [];
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            hidehelp:'=',
            legend: '@',
            help: '@',
            hideOptions: "="
        },
        replace: true,
        controller: optionsCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/optionsDirective.html'
    };
};
